import styled from "styled-components";

interface IInputStyled{
  heightInput?: string;
  resize?: boolean;
}

const InputStyled = styled.textarea<IInputStyled>`
  background: var(--input-background-color);
  border: none;
  border: 1px solid ${(props) => props.color ? `${props.color}` : "var(--border-color)"};
  padding: 0.1rem 0.25rem;
  border-radius: 8px;
  display: flex;
  flex: 1;
  height: ${(props) => props.heightInput ? `${props.heightInput}` : "auto"};
  font-size: 0.9rem;
  width: 100%;
  ${(props) => props.resize ? "" : "resize: none;"}
`;

export default InputStyled;

